import React, { useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import { SolarWindsCard } from "./SolarWindsCard.js"; // Renamed for clarity

// Import your images...
import security from "../../assets/SW/security.png";
import monitor from "../../assets/SW/monitor.png";
import app from "../../assets/SW/watch.png";
import infra from "../../assets/SW/syslog.png";
import db from "../../assets/SW/DB.png";
import ip from "../../assets/SW/UDT.png";
import network from "../../assets/SW/network.png";
import nta from "../../assets/SW/NTA.png";
import analyz from "../../assets/SW/Analyz.png";
import arm from "../../assets/SW/Arm.png";
import web from "../../assets/SW/web.png";

// Combine all modules into one array for easier mapping
const allModules = [
  {
    title: "Infrastructure Monitoring",
    image: infra,
    description:
      "A vendor-agnostic solution for monitoring IT infrastructure across on-premises, cloud, or hybrid environments.",
    description1:
      "Assure the health and configuration of physical and virtual servers, containers, private cloud, storage, and network infrastructure.",
  },
  {
    title: "Application Monitoring",
    image: app,
    description:
      "Integrated, full-stack observability to connect data from web apps, services, cloud/hybrid infrastructures, databases, and networks.",
    description1:
      "Collects metrics, logs, traces, and user experience data for holistic visibility into application performance.",
  },
  {
    title: "Network Configuration Monitoring",
    image: network,
    description:
      "Saves time and improves network reliability and security by managing configurations, changes, and compliance for routers, switches, and firewalls.",
    description1:
      "Supports a wide range of multi-vendor devices from Cisco®, Juniper®, HP, Dell®, and more.",
  },
  {
    title: "Database Monitoring",
    image: db,
    description:
      "A unified approach to cross-platform database performance monitoring, whether on-premises or in the cloud.",
    description1:
      "Offers intuitive configuration for monitoring multiple servers from a variety of vendors.",
  },
  {
    title: "Traffic Insights (NTA)",
    image: nta,
    description:
      "Capture data from continuous network traffic streams and convert it into easy-to-interpret charts to understand network usage.",
    description1:
      "Analyze Cisco® NetFlow, Juniper® J-Flow™, IPFIX, sFlow®, and other flow data to see who is using the network and for what.",
  },
  {
    title: "Log Intelligence",
    image: analyz,
    description:
      "Simplifies log management with a holistic, multi-source log observability solution.",
    description1:
      "Supports almost every log type, as well as OpenTelemetry and third-party integrations.",
  },
  {
    title: "Security Event Manager (SEM)",
    image: security,
    description:
      "Affordable and efficient threat detection, automated incident response, and compliance reporting.",
    description1:
      "Combines log management, threat detection, file integrity monitoring, and active response in an easy-to-deploy virtual appliance.",
  },
  {
    title: "IP Address Manager (IPAM)",
    image: ip,
    description:
      "Provides centralized IP address management, working hand-in-hand with unified DHCP and DNS administration.",
    description1:
      "Helps teams quickly find and configure available addresses on DHCP and DNS systems.",
  },
  {
    title: "Access Rights Manager (ARM)",
    image: arm,
    description:
      "Manage compliance requirements (GDPR, PCI, HIPAA) by monitoring user access to critical data.",
    description1:
      "Delivers customized Active Directory (AD) and Azure AD reports showing who has access to what and when they accessed it.",
  },
  {
    title: "Server Configuration Monitor (SCM)",
    image: monitor,
    description:
      "Quickly reveal when server, application, or database configurations change, who changed them, and the performance impact.",
    description1:
      "Provides visibility to troubleshoot faster, improve security, and demonstrate compliance.",
  },
  {
    title: "Storage Resource Management",
    image: nta, // You might want a different icon for storage
    description:
      "Maximize the efficiency of storage capacity, allocation, and usage across your environment (RAID, LUN, datastore, etc.).",
    description1:
      "Centralize storage data in a single platform to analyze data across devices from multiple vendors.",
  },
  {
    title: "Website Performance Monitoring",
    image: web,
    description:
      "Monitor critical website performance metrics in real-time, down to the individual webpage, for optimal end-user experience.",
    description1:
      "Granular views, alerts, and data visualization ensure your website is running quickly and smoothly.",
  },
];

export const Accordion = () => {
  useEffect(() => {
    Aos.init({ duration: 1000, once: true }); // 'once: true' makes animations happen only once
  }, []);

  return (
    <section className="solarwinds-section">
      {/* 1. Introduction / Hero Section */}
      <div className="sw-intro-container" data-aos="fade-up">
        <h1 className="sw-title">Full-Stack Observability with SolarWinds</h1>
        <p className="sw-subtitle">
          Gain actionable insights, manage hybrid IT, and ensure peak performance across your entire technology stack—from the network to the application.
        </p>
      </div>

      {/* 2. The Cards Grid */}
      <div className="sw-cards-grid">
        {allModules.map((module, index) => (
          <div key={index} data-aos="fade-up" data-aos-delay={index * 100}>
            <SolarWindsCard {...module} />
          </div>
        ))}
      </div>
    </section>
  );
};